import React from 'react';
import { Form } from 'react-bootstrap'; // Removed Col import
import { Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { isValid } from 'date-fns';
import "./FormDatePicker.css";
import { getNestedError } from '../../utils/formUtils'; // Corrected import path

const FormDatePicker = ({ name, label, control, errors, isRequired = false, minDate = null, maxDate = null, showTimeSelect = false, showTimeSelectOnly = false, timeIntervals = 15, dateFormat = "dd/MM/yyyy", timeCaption = "Time", placeholderText = "DD-MM-YYYY", ...props }) => (
    // Removed Col wrapper here, expecting parent to provide it
    <Form.Group className="mb-4">
        <Form.Label className="form-label">{label} {isRequired && <span className="text-danger">*</span>}</Form.Label>
        <Controller name={name} control={control} rules={props.rules || {}} render={({ field }) => ( // Adjusted rules prop usage
            <DatePicker 
                selected={field.value && isValid(field.value) ? field.value : null}
                onChange={(date) => field.onChange(date)} 
                dateFormat={dateFormat} 
                className={`custom-form-input ${getNestedError(errors, name) ? 'is-invalid' : ''}`}
                calendarClassName="custom-dark-datepicker"
                placeholderText={placeholderText} 
                showYearDropdown 
                showMonthDropdown
                // dropdownMode="select"
                scrollableYearDropdown 
                yearDropdownItemNumber={100} 
                maxDate={maxDate || new Date()} 
                minDate={minDate} // Added minDate here
                showTimeSelect={showTimeSelect}
                showTimeSelectOnly={showTimeSelectOnly}
                timeIntervals={timeIntervals}
                timeCaption={timeCaption}
                popperPlacement="top-start"
                {...props} // Pass remaining props
            />
        )} />
        {getNestedError(errors, name) && <Form.Control.Feedback type="invalid">{getNestedError(errors, name)?.message}</Form.Control.Feedback>}
    </Form.Group>
);

export default FormDatePicker;